
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.2385',
  depVersions: {
  "customer-portal-app": "static-1.2385",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.468",
  "data-fetching-client": "static-1.9691",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.455",
  "growth-payments-core": "static-1.25450",
  "head-dlb": "static-1.5007",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5614",
  "hs-test-utils": "static-1.8037",
  "hub-http": "static-1.6245",
  "hub-http-shared-msw-handlers": "static-1.10022",
  "hubspot-dlb": "static-2.1854",
  "hubspot-prosemirror": "static-1.18299",
  "hubspot-url-utils": "static-1.4132",
  "HubStyleTokens": "static-2.11496",
  "I18n": "static-7.1631",
  "immutable": "static-2.79",
  "jasmine-runner": "static-1.6487",
  "payment-link-components": "static-1.23609",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7062",
  "quartz-core": "static-1.6281",
  "quartz-i18n": "static-1.737",
  "react": "static-7.186",
  "react-colorpicker": "static-2.10231",
  "react-dlb": "static-1.79",
  "react-utils": "static-2.5362",
  "rich-text-lib": "static-1.19873",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.18032",
  "ui-components-test-utils": "static-1.5633",
  "UIComponents": "static-3.8442",
  "foundations-assets": "static-1.4892",
  "foundations-components": "static-1.7983",
  "foundations-theming": "static-1.4444",
  "foundations-theming-specialty": "static-1.2160",
  "framer-motion": "static-1.72",
  "metrics-js": "static-1.9637",
  "PortalIdParser": "static-2.404",
  "portals-platform-lib": "static-1.935",
  "quartz-config": "static-1.840",
  "quartz-routing": "static-1.492",
  "quick-fetch": "static-1.3934",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16695",
  "rpc-client-utils": "static-1.4676",
  "sanitize-text": "static-1.8166",
  "styled-components": "static-2.89",
  "tanstack-table": "static-1.55",
  "ui-addon-draggable": "static-3.4787",
  "ui-addon-react-router-dom": "static-1.9566",
  "usage-tracker": "static-1.7371",
  "usage-tracker-anonymous": "static-1.5788",
  "usage-tracker-core": "static-1.7221",
  "video-components-external": "static-1.11353",
  "apollo-stack-hubspot": "static-3.84",
  "hs-promise-rejection-tracking": "static-1.5587",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.71",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3417",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3339",
  "quartz-webpack": "static-1.3286",
  "bend-plugin-quartz-routing": "static-1.140",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.82",
  "customer-data-objects": "static-1.7697",
  "frontend-preferences-client": "static-1.7951",
  "laboratory-lib": "static-3.7179",
  "onboarding-scopes": "static-1.6485",
  "seat-types-lib": "static-1.66",
  "ui-addon-opt": "static-4.8388",
  "HeadJS": "static-2.764",
  "hs-test-utils-bend-plugin": "static-1.3148",
  "msw": "static-1.39",
  "testing-library": "static-1.152",
  "hs-locale-management": "static-1.98",
  "ts-schema": "static-1.4098",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7787",
  "cssUtils": "static-1.798",
  "customer-data-ui-utilities": "static-1.9850",
  "HubStyle": "static-2.11803",
  "knowledge-content-types": "static-1.8496",
  "PatternValidationJS": "static-1.437",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.487",
  "ui-addon-emoji-picker": "static-1.9912",
  "ui-addon-i18n": "static-1.11172",
  "ui-business-units-lib": "static-1.9078",
  "ui-shepherd-react": "static-3.10194",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.83",
  "jasmine": "static-4.4351",
  "commerce-tours-lib": "static-1.6147",
  "customer-data-properties": "static-1.51646",
  "getting-started-shared-tasks": "static-1.18520",
  "growth-onboarding-reliability": "static-1.5106",
  "onboarding-tours": "static-1.16658",
  "reference-resolvers-lite": "static-1.8118",
  "sales-checkout-service-client": "static-1.3665",
  "ui-addon-iframeable": "static-1.9083",
  "user-context": "static-1.5129",
  "dispatcher": "static-1.137",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.838",
  "hubspotter-http": "static-1.4669",
  "icons": "static-2.650",
  "mobile-manifest-mixins": "static-1.538",
  "module-federation": "static-1.23",
  "quartz-auth": "static-1.737",
  "quartz-head": "static-1.727",
  "quartz-test": "static-1.737",
  "quartz-tracking": "static-1.441",
  "ui-fonts": "static-1.758",
  "usage-tracker-container": "static-1.7361",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9448",
  "data-token-picker": "static-1.16447",
  "FileManagerLib": "static-1.39328",
  "property-translator": "static-1.5423",
  "atom": "static-1.5096",
  "merchandise-lib": "static-1.264",
  "purchase-motions-components": "static-1.5961",
  "salesImages": "static-1.525",
  "SharedI18nStrings": "static-1.182",
  "foundations-components-test-utils": "static-1.5466",
  "react-select-plus": "static-1.105",
  "react-virtualized": "static-2.99",
  "ui-images": "static-2.1160",
  "bend-plugin-foundations-components": "static-1.4252",
  "floating-ui": "static-1.56",
  "react-aria": "static-1.66",
  "react-create-root-preference": "static-1.29",
  "trellis-assets": "static-1.2023",
  "bend-plugin-foundations-theming": "static-1.2927",
  "foundations-theming-base": "static-1.3429",
  "stylex": "static-1.33",
  "interframe": "static-3.4783",
  "js-cookie": "static-1.18",
  "usage-tracker-multi": "static-1.5785",
  "web-vitals": "static-1.6",
  "bend-plugin-chirp-manifest": "static-1.86",
  "chirp-fetch": "static-1.1911",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4500",
  "react-flip-move": "static-1.70",
  "apollo-link-hub-http": "static-2.4675",
  "content-media-composition-data-lib": "static-1.12397",
  "content-media-compositions": "static-2.16404",
  "idb-keyval": "static-1.44",
  "immer": "static-1.33",
  "immerable": "static-1.4177",
  "magpie-lib": "static-1.5566",
  "magpie-types": "static-1.5026",
  "media-bridge-lib": "static-1.18966",
  "video-data-lib": "static-1.35011",
  "bender-build-tools": "static-1.3215",
  "inbound-db-properties-service-client": "static-1.3864",
  "superstore": "static-1.4785",
  "feedback-loader": "static-1.29338",
  "ai-components-ui-library": "static-1.9035",
  "ui-addon-video-player": "static-1.8726",
  "ui-coaching-tips": "static-1.28630",
  "sassPrefix": "static-1.156",
  "react-dnd-compat": "static-1.4638",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2522",
  "navigation-messaging": "static-1.7437",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8194",
  "reselect": "static-2.16",
  "commerce-products-lib": "static-1.9656",
  "crm-message-bus": "static-1.43040",
  "growth-data-modal": "static-1.5464",
  "hubspot-apollo-client": "static-1.4903",
  "onboarding-tours-client": "static-1.4872",
  "calling-global-api": "static-1.64596",
  "calling-internal-common": "static-1.31326",
  "calling-lifecycle-internal": "static-1.65978",
  "calling-lifecycle-messages": "static-1.58272",
  "conditional-properties-service-client": "static-1.3815",
  "crm-links": "static-1.6318",
  "customer-data-objects-ui-components": "static-1.13052",
  "customer-data-properties-shared-msw-handlers": "static-1.9349",
  "customer-data-property-utils": "static-1.8114",
  "external-options-client-types": "static-1.4177",
  "file-manager-components": "static-1.23688",
  "framework-data-schema-resolvers": "static-1.6908",
  "google-libphonenumber": "static-1.38",
  "hs-resources": "static-1.177",
  "inbound-db-meta-service-client": "static-1.3604",
  "inbounddb-objects-service-types": "static-1.4241",
  "meetings-icalendar-utils-lib": "static-1.655",
  "multi-currency-client-types": "static-1.3709",
  "object-builder-ui-client": "static-1.48825",
  "pipeline-validation-client-types": "static-1.3983",
  "property-value-citations": "static-1.2260",
  "pulse": "static-1.601",
  "smart-property-lib": "static-1.7209",
  "tiered-pricing": "static-1.1270",
  "zustand": "static-1.74",
  "ui-addon-form-validation": "static-1.11014",
  "growth-onboarding-confetti": "static-1.3090",
  "growth-onboarding-next-action-utils": "static-1.1990",
  "navigation-components": "static-1.18110",
  "onboarding-tours-utils": "static-1.724",
  "ui-shepherd-tracker": "static-1.7575",
  "ui-universal-auth": "static-1.9006",
  "batch-promise": "static-1.1565",
  "getting-started-shared-tasks-store": "static-1.17638",
  "hubspotter-http-shared-msw-handlers": "static-1.10020",
  "usage-tracker-session-replay": "static-1.5057",
  "audio-components": "static-1.5950",
  "FileManagerCore": "static-1.39187",
  "FileManagerImages": "static-1.36839",
  "video-components": "static-1.13356",
  "foundations-components-legacy": "static-1.1008",
  "purchase-motions-api": "static-1.5964",
  "signup-constants": "static-1.18886",
  "signup-ui-url-generator": "static-2.8076",
  "usage-tracker-public": "static-1.7182",
  "reactive-lib": "static-1.747",
  "simple-logging-lib": "static-1.3074",
  "chatspot-core": "static-1.21412",
  "ContentUtils": "static-1.68437",
  "copilot-toolkit": "static-1.11196",
  "growth-onboarding-feedback-components": "static-1.6604",
  "commerce-permissions": "static-1.793",
  "customer-data-tracking": "static-1.6913",
  "products-iframe-lib": "static-1.8005",
  "products-ui-components-shared-msw-handlers": "static-1.10404",
  "restore-request-side-panel-lib": "static-1.946",
  "onboarding-data-sync-lib": "static-1.1993",
  "hubspot-apollo-cache": "static-1.362",
  "calling-error-reporting": "static-1.31333",
  "shared-worker-versioning": "static-1.11060",
  "calling-usage-tracker": "static-1.6565",
  "self-service-api": "static-1.10271",
  "voice-sms-access-library": "static-1.1080",
  "conversations-skeleton-state": "static-1.7271",
  "location-customization-utils-lib": "static-1.9336",
  "crm-pipelines-api-client-types": "static-1.4157",
  "fdsr-migration-layer": "static-1.27",
  "framework-builder-read-service-client": "static-1.4023",
  "framework-data-schema-quick-fetch": "static-1.6813",
  "persist-promise": "static-1.3722",
  "bend-plugin-pulse": "static-1.104",
  "directed-graph": "static-1.959",
  "event-emitter": "static-1.971",
  "fast-json-patch": "static-1.63",
  "data-agent-kit": "static-1.231",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10105",
  "fsm": "static-1.3755",
  "policy-lib": "static-1.6801",
  "react-tinymce": "static-1.55311",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10168",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54437",
  "tinymce-plugins": "static-1.57551",
  "tinymce-themes": "static-1.56407",
  "growth-onboarding-next-action-components": "static-1.2018",
  "user-context-client": "static-1.4636",
  "nest": "static-1.253",
  "unified-auth-core-lib": "static-1.802",
  "amplitude-session-replay-browser": "static-1.60",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4560",
  "video-embed": "static-1.35845",
  "content-icons-ui": "static-1.2233",
  "social-insights-client-types": "static-1.22183",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4836",
  "integrations-lib": "static-1.16234",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4283",
  "InboxConnectUtils": "static-4.14883",
  "meetings-connect-utils-lib": "static-1.7629",
  "calling-orchestration-schema": "static-1.35857",
  "crm-record-cards-service-types": "static-1.3615",
  "highcharts": "static-8.104",
  "trellis-story-utils": "static-1.4539",
  "storybook-react": "static-1.33",
  "hub-http-contrib": "static-1.3066",
  "tinymce-data": "static-1.40522",
  "ui-addon-sales-email": "static-1.5234",
  "codemirror": "static-5.95",
  "layout-dnd-components": "static-1.12490",
  "layout-dnd-utils": "static-1.11465",
  "react-codemirror": "static-1.10650",
  "ui-brand-identity-lib": "static-1.15377",
  "NamespacedHubStyle": "static-2.9076",
  "outpost": "static-1.4203",
  "flux-actions": "static-1.341",
  "integrations-error-boundary-lib": "static-1.13649",
  "integrations-tracking-lib": "static-1.5625",
  "native-integrations-shared-strings": "static-1.7805",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10390",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.520",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68512",
  "layout-data-lib": "static-1.9790",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.3037",
  "google-sheets-integration-lib": "static-1.312",
  "microsoft-drive-integration-lib": "static-1.444",
  "slack-ui-library": "static-1.10416",
  "advanced-menus-core": "static-1.15164",
  "advanced-menus-lib": "static-1.12102",
  "ExportDialog": "static-6.10408",
  "ui-memberships-settings-lib": "static-1.34115",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15163",
  "simple-menus-lib": "static-1.16680"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.2385",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.468",
  "data-fetching-client": "/data-fetching-client/static-1.9691",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.455",
  "growth-payments-core": "/growth-payments-core/static-1.25450",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5614",
  "hs-test-utils": "/hs-test-utils/static-1.8037",
  "hub-http": "/hub-http/static-1.6245",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10022",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18299",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyleTokens": "/HubStyleTokens/static-2.11496",
  "I18n": "/I18n/static-7.1631",
  "immutable": "/immutable/static-2.79",
  "jasmine-runner": "/jasmine-runner/static-1.6487",
  "payment-link-components": "/payment-link-components/static-1.23609",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7062",
  "quartz-core": "/quartz-core/static-1.6281",
  "quartz-i18n": "/quartz-i18n/static-1.737",
  "react": "/react/static-7.186",
  "react-colorpicker": "/react-colorpicker/static-2.10231",
  "react-dlb": "/react-dlb/static-1.79",
  "react-utils": "/react-utils/static-2.5362",
  "rich-text-lib": "/rich-text-lib/static-1.19873",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18032",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5633",
  "UIComponents": "/UIComponents/static-3.8442",
  "foundations-assets": "/foundations-assets/static-1.4892",
  "foundations-components": "/foundations-components/static-1.7983",
  "foundations-theming": "/foundations-theming/static-1.4444",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2160",
  "framer-motion": "/framer-motion/static-1.72",
  "metrics-js": "/metrics-js/static-1.9637",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "portals-platform-lib": "/portals-platform-lib/static-1.935",
  "quartz-config": "/quartz-config/static-1.840",
  "quartz-routing": "/quartz-routing/static-1.492",
  "quick-fetch": "/quick-fetch/static-1.3934",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16695",
  "rpc-client-utils": "/rpc-client-utils/static-1.4676",
  "sanitize-text": "/sanitize-text/static-1.8166",
  "styled-components": "/styled-components/static-2.89",
  "tanstack-table": "/tanstack-table/static-1.55",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4787",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9566",
  "usage-tracker": "/usage-tracker/static-1.7371",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5788",
  "usage-tracker-core": "/usage-tracker-core/static-1.7221",
  "video-components-external": "/video-components-external/static-1.11353",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.71",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3417",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3339",
  "quartz-webpack": "/quartz-webpack/static-1.3286",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.140",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.82",
  "customer-data-objects": "/customer-data-objects/static-1.7697",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7951",
  "laboratory-lib": "/laboratory-lib/static-3.7179",
  "onboarding-scopes": "/onboarding-scopes/static-1.6485",
  "seat-types-lib": "/seat-types-lib/static-1.66",
  "ui-addon-opt": "/ui-addon-opt/static-4.8388",
  "HeadJS": "/HeadJS/static-2.764",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3148",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.152",
  "hs-locale-management": "/hs-locale-management/static-1.98",
  "ts-schema": "/ts-schema/static-1.4098",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7787",
  "cssUtils": "/cssUtils/static-1.798",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9850",
  "HubStyle": "/HubStyle/static-2.11803",
  "knowledge-content-types": "/knowledge-content-types/static-1.8496",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9912",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11172",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9078",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10194",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.83",
  "jasmine": "/jasmine/static-4.4351",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6147",
  "customer-data-properties": "/customer-data-properties/static-1.51646",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18520",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5106",
  "onboarding-tours": "/onboarding-tours/static-1.16658",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8118",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3665",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9083",
  "user-context": "/user-context/static-1.5129",
  "dispatcher": "/dispatcher/static-1.137",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.838",
  "hubspotter-http": "/hubspotter-http/static-1.4669",
  "icons": "/icons/static-2.650",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.538",
  "module-federation": "/module-federation/static-1.23",
  "quartz-auth": "/quartz-auth/static-1.737",
  "quartz-head": "/quartz-head/static-1.727",
  "quartz-test": "/quartz-test/static-1.737",
  "quartz-tracking": "/quartz-tracking/static-1.441",
  "ui-fonts": "/ui-fonts/static-1.758",
  "usage-tracker-container": "/usage-tracker-container/static-1.7361",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9448",
  "data-token-picker": "/data-token-picker/static-1.16447",
  "FileManagerLib": "/FileManagerLib/static-1.39328",
  "property-translator": "/property-translator/static-1.5423",
  "atom": "/atom/static-1.5096",
  "merchandise-lib": "/merchandise-lib/static-1.264",
  "purchase-motions-components": "/purchase-motions-components/static-1.5961",
  "salesImages": "/salesImages/static-1.525",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5466",
  "react-select-plus": "/react-select-plus/static-1.105",
  "react-virtualized": "/react-virtualized/static-2.99",
  "ui-images": "/ui-images/static-2.1160",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4252",
  "floating-ui": "/floating-ui/static-1.56",
  "react-aria": "/react-aria/static-1.66",
  "react-create-root-preference": "/react-create-root-preference/static-1.29",
  "trellis-assets": "/trellis-assets/static-1.2023",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2927",
  "foundations-theming-base": "/foundations-theming-base/static-1.3429",
  "stylex": "/stylex/static-1.33",
  "interframe": "/interframe/static-3.4783",
  "js-cookie": "/js-cookie/static-1.18",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5785",
  "web-vitals": "/web-vitals/static-1.6",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.86",
  "chirp-fetch": "/chirp-fetch/static-1.1911",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4500",
  "react-flip-move": "/react-flip-move/static-1.70",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4675",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12397",
  "content-media-compositions": "/content-media-compositions/static-2.16404",
  "idb-keyval": "/idb-keyval/static-1.44",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4177",
  "magpie-lib": "/magpie-lib/static-1.5566",
  "magpie-types": "/magpie-types/static-1.5026",
  "media-bridge-lib": "/media-bridge-lib/static-1.18966",
  "video-data-lib": "/video-data-lib/static-1.35011",
  "bender-build-tools": "/bender-build-tools/static-1.3215",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3864",
  "superstore": "/superstore/static-1.4785",
  "feedback-loader": "/feedback-loader/static-1.29338",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9035",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8726",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28630",
  "sassPrefix": "/sassPrefix/static-1.156",
  "react-dnd-compat": "/react-dnd-compat/static-1.4638",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2522",
  "navigation-messaging": "/navigation-messaging/static-1.7437",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8194",
  "reselect": "/reselect/static-2.16",
  "commerce-products-lib": "/commerce-products-lib/static-1.9656",
  "crm-message-bus": "/crm-message-bus/static-1.43040",
  "growth-data-modal": "/growth-data-modal/static-1.5464",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4903",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4872",
  "calling-global-api": "/calling-global-api/static-1.64596",
  "calling-internal-common": "/calling-internal-common/static-1.31326",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65978",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58272",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3815",
  "crm-links": "/crm-links/static-1.6318",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13052",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9349",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8114",
  "external-options-client-types": "/external-options-client-types/static-1.4177",
  "file-manager-components": "/file-manager-components/static-1.23688",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6908",
  "google-libphonenumber": "/google-libphonenumber/static-1.38",
  "hs-resources": "/hs-resources/static-1.177",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3604",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4241",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.655",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3709",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48825",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3983",
  "property-value-citations": "/property-value-citations/static-1.2260",
  "pulse": "/pulse/static-1.601",
  "smart-property-lib": "/smart-property-lib/static-1.7209",
  "tiered-pricing": "/tiered-pricing/static-1.1270",
  "zustand": "/zustand/static-1.74",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11014",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3090",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1990",
  "navigation-components": "/navigation-components/static-1.18110",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.724",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7575",
  "ui-universal-auth": "/ui-universal-auth/static-1.9006",
  "batch-promise": "/batch-promise/static-1.1565",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17638",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10020",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5057",
  "audio-components": "/audio-components/static-1.5950",
  "FileManagerCore": "/FileManagerCore/static-1.39187",
  "FileManagerImages": "/FileManagerImages/static-1.36839",
  "video-components": "/video-components/static-1.13356",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1008",
  "purchase-motions-api": "/purchase-motions-api/static-1.5964",
  "signup-constants": "/signup-constants/static-1.18886",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8076",
  "usage-tracker-public": "/usage-tracker-public/static-1.7182",
  "reactive-lib": "/reactive-lib/static-1.747",
  "simple-logging-lib": "/simple-logging-lib/static-1.3074",
  "chatspot-core": "/chatspot-core/static-1.21412",
  "ContentUtils": "/ContentUtils/static-1.68437",
  "copilot-toolkit": "/copilot-toolkit/static-1.11196",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6604",
  "commerce-permissions": "/commerce-permissions/static-1.793",
  "customer-data-tracking": "/customer-data-tracking/static-1.6913",
  "products-iframe-lib": "/products-iframe-lib/static-1.8005",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10404",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.946",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1993",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.362",
  "calling-error-reporting": "/calling-error-reporting/static-1.31333",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11060",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6565",
  "self-service-api": "/self-service-api/static-1.10271",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.1080",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7271",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9336",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4157",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.27",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4023",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6813",
  "persist-promise": "/persist-promise/static-1.3722",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.104",
  "directed-graph": "/directed-graph/static-1.959",
  "event-emitter": "/event-emitter/static-1.971",
  "fast-json-patch": "/fast-json-patch/static-1.63",
  "data-agent-kit": "/data-agent-kit/static-1.231",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10105",
  "fsm": "/fsm/static-1.3755",
  "policy-lib": "/policy-lib/static-1.6801",
  "react-tinymce": "/react-tinymce/static-1.55311",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10168",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54437",
  "tinymce-plugins": "/tinymce-plugins/static-1.57551",
  "tinymce-themes": "/tinymce-themes/static-1.56407",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2018",
  "user-context-client": "/user-context-client/static-1.4636",
  "nest": "/nest/static-1.253",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.802",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4560",
  "video-embed": "/video-embed/static-1.35845",
  "content-icons-ui": "/content-icons-ui/static-1.2233",
  "social-insights-client-types": "/social-insights-client-types/static-1.22183",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4836",
  "integrations-lib": "/integrations-lib/static-1.16234",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4283",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14883",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7629",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35857",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3615",
  "highcharts": "/highcharts/static-8.104",
  "trellis-story-utils": "/trellis-story-utils/static-1.4539",
  "storybook-react": "/storybook-react/static-1.33",
  "hub-http-contrib": "/hub-http-contrib/static-1.3066",
  "tinymce-data": "/tinymce-data/static-1.40522",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5234",
  "codemirror": "/codemirror/static-5.95",
  "layout-dnd-components": "/layout-dnd-components/static-1.12490",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11465",
  "react-codemirror": "/react-codemirror/static-1.10650",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15377",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9076",
  "outpost": "/outpost/static-1.4203",
  "flux-actions": "/flux-actions/static-1.341",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13649",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5625",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7805",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10390",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.520",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68512",
  "layout-data-lib": "/layout-data-lib/static-1.9790",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3037",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.312",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.444",
  "slack-ui-library": "/slack-ui-library/static-1.10416",
  "advanced-menus-core": "/advanced-menus-core/static-1.15164",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12102",
  "ExportDialog": "/ExportDialog/static-6.10408",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34115",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15163",
  "simple-menus-lib": "/simple-menus-lib/static-1.16680"
}
};
